//import axios from 'axios';
import Conversation, { GenericResponse } from '../models/Conversation';
import { errorMessage } from '../models/Constants';


// const API_KEY = process.env.REACT_APP_API_KEY!;
// const API_USERNAME = process.env.REACT_APP_USERNAME!;
let URL:string = "https://us-south.functions.appdomain.cloud/api/v1/web/9689c24d-8aea-4a97-b9a5-28583aed2ca5/default/key_provider";



export const sendMessage = (messageText: any, context: any) => {
  // console.log(!context.conversation_id);
  // console.log(messageText)

  const buttons = document.getElementsByTagName("button"); //To disable buttons on clicking quick response
      for (let i = 0; i < buttons.length; i++) {
        buttons[i].disabled = true;
        buttons[i].style.color = "#000000de";
        buttons[i].style.background = "#eeeeee";
      } 
      
  //document.getElementById('quickRespGrid')!.remove(); //To delete quick response options
  
  return new Promise((resolve, reject) => {

    fetch(URL, {
      method:'POST',
      headers:  new Headers({
        'Content-Type':'application/json',
        // 'Authorization': 'Basic ' + btoa(API_USERNAME + ":" + API_KEY)
      }),
      body: JSON.stringify({
        locale:'en-KY',   
        /*
        en-IN for english, 
        uat-IN for UAT
        hi-IN for Hindi 
        en-KY = Kenya 
        en-BW = Botswana 
        en-FJ = Fiji 
        en-MT = Mauritius 
        en-OM = Oman 
        en-TZ = Tanzania 
        en-UAE = UAE 
        en-UG = Uganda
        */
        input: {          
          text: messageText
        },
        context: context
      })
    })
      .then(res => res.json())
      .then(
        (response) => {
         // console.log(JSON.stringify(response));        
          if(!response.output.generic){
            //response.output.generic = [{response_type: "text", text: errorMessage[Math.floor(Math.random() * errorMessage.length)]}]
            response.output.generic = [{response_type: "text", text: errorMessage[crypto.getRandomValues(new Uint8Array(1))[0]]}]
          }
        
          //console.log(JSON.stringify(transcript))
          const gResponses = response.output.generic.map((res: any)=>{
            const genRes:GenericResponse = new GenericResponse(res);
            switch (res.response_type) {
              case 'option':
                genRes.parseOptionResponse(response.context);
                return genRes;
              case 'image':
                genRes.parseImageResponse();
                return genRes;
              case 'text_link':
                genRes.parseTextLinkResponse();
                return genRes;
              case 'text':default:
                genRes.parseTextResponse();
                return genRes;
            }
          });
    
          resolve({context: response.context, genericResponses: gResponses} as Conversation);
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          reject(error);
        }
      )


  })
  
}

// export const sendMessageProd = (messageText: any, context: any) => {
//   // console.log(!context.conversation_id);
//   // console.log(messageText)

//   const buttons = document.getElementsByTagName("button"); //To disable buttons on clicking quick response
//       for (let i = 0; i < buttons.length; i++) {
//         buttons[i].disabled = true;
//         buttons[i].style.color = "#000000de";
//         buttons[i].style.background = "#eeeeee";
//       } 
      
//   //document.getElementById('quickRespGrid')!.remove(); //To delete quick response options
  
//   return new Promise((resolve, reject) => {

//     fetch(URL, {
//       method:'POST',
//       headers:  new Headers({
//         'Content-Type':'application/json',
//         // 'Authorization': 'Basic ' + btoa(API_USERNAME + ":" + API_KEY)
//       }),
//       body: JSON.stringify({
//         input: {          
//           text: messageText
//         },
//         context: context
//       })
//     })
//       .then(res => res.json())
//       .then(
//         (response) => {
//          // console.log(JSON.stringify(response));        
//           if(!response.output.generic){
//             //response.output.generic = [{response_type: "text", text: errorMessage[Math.floor(Math.random() * errorMessage.length)]}]
//             response.output.generic = [{response_type: "text", text: errorMessage[crypto.getRandomValues(new Uint8Array(1))[0]]}]
//           }
//           //transcript[i] = {'que': messageText, answer:response.output.generic};
//           //i++;
//           //console.log(JSON.stringify(transcript))
//           const gResponses = response.output.generic.map((res: any)=>{
//             const genRes:GenericResponse = new GenericResponse(res);
//             switch (res.response_type) {
//               case 'option':
//                 genRes.parseOptionResponse(response.context);
//                 return genRes;
//               case 'image':
//                 genRes.parseImageResponse();
//                 return genRes;
//               case 'text_link':
//                 genRes.parseTextLinkResponse();
//                 return genRes;
//               case 'text':default:
//                 genRes.parseTextResponse();
//                 return genRes;
//             }
//           });
    
//           resolve({context: response.context, genericResponses: gResponses} as Conversation);
//         },
//         // Note: it's important to handle errors here
//         // instead of a catch() block so that we don't swallow
//         // exceptions from actual bugs in components.
//         (error) => {
//           reject(error);
//         }
//       )


//   })
  
// }

